import Vue from 'vue'
import Router from 'vue-router'
const Index = () =>
  import(/* webpackChunkName: "loading" */ '../pages/Index.vue')
const ActivityDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/ActivityDetail.vue')
const ResidentActivityDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/ResidentActivityDetail.vue')
const Seckill = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/Seckill.vue')
const Material = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/Material.vue')
const CouponDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/CouponDetail.vue')
const CardBagDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/CardBagDetail.vue')
const ReportCityMap = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/ReportCityMap.vue')
const AddPower = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/AddPower.vue')
const ImportStore = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/ImportStore.vue')
  const ImportSales = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/ImportSales.vue')  
const RollDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/fissionEquitys/rollDetail.vue')
const SeckilllDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/fissionEquitys/seckilllDetail.vue')
  const CardDetail = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/fissionEquitys/cardDetail.vue')
  const PrivacyPolicy = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/privacyPolicy.vue')
  const ElectronicCard = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/electronicCard/details.vue')
  const ActivityList = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/electronicCard/activityList.vue')
  const ElectronicCardMaterial = () =>
  import(/* webpackChunkName: "group-foo" */ '../pages/electronicCard/material.vue')
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
    },
    {
      path: '/activitydetail',
      name: 'ActivityDetail',
      component: ActivityDetail,
    },
    {
      path: '/residentActivityDetail',
      name: 'ResidentActivityDetail',
      component: ResidentActivityDetail,
    },
    {
      path: '/material',
      name: 'Material',
      component: Material,
    },
    {
      path: '/couponDetail',
      name: 'CouponDetail',
      component: CouponDetail,
    },
    {
      path: '/seckill',
      name: 'Seckill',
      component: Seckill,
    },
    {
      path: '/cardBagDetail',
      name: 'CardBagDetail',
      component: CardBagDetail,
    },
    {
      path: '/reportCityMap',
      name: 'ReportCityMap',
      component: ReportCityMap,
    },
    {
      path: '/addPower',
      name: 'AddPower',
      component: AddPower,
    },
    {
      path: '/importStore',
      name: 'ImportStore',
      component: ImportStore,
    },
    {
      path: '/importSales',
      name: 'ImportSales',
      component: ImportSales,
    },
    {
      path: '/fissionEquitys/rollDetail',
      name: 'RollDetail',
      component: RollDetail,
    },
    {
      path: '/fissionEquitys/seckilllDetail',
      name: 'SeckilllDetail',
      component: SeckilllDetail,
    },
    {
      path: '/fissionEquitys/cardDetail',
      name: 'CardDetail',
      component: CardDetail,
    },
    {
      path: '/privacyPolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/electronicCard/details',
      name: 'ElectronicCard',
      component: ElectronicCard,
    },
    {
      path: '/electronicCard/activityList',
      name: 'ActivityList',
      component: ActivityList,
    },
    {
      path: '/electronicCard/material',
      name: 'electronicCardMaterial',
      component: ElectronicCardMaterial,
    }
  ],
})
